import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { LectionaryTrackEditComponent } from '../lectionary-track-edit/lectionary-track-edit.component';


@Component({
  selector: 'app-lectionary-track',
  templateUrl: './lectionary-track.component.html',
  styleUrls: ['./lectionary-track.component.css']
})
export class LectionaryTrackComponent implements OnInit {

  public entities: LectionaryTrack[];
  public isLoading = false;


    constructor(
      public dialog: MatDialog,
      private apiSvc: ApiService
    ) { }

    ngOnInit() {
      this.loadEntities();
    }

    private loadEntities() {
      this.isLoading = true;
      this.apiSvc.get("api/LectionaryTrack", null).subscribe(
        (data: LectionaryTrack[]) => {
          this.entities = data;
          console.log(this.entities);
          this.isLoading = false;
        },
        (err) => {
          console.log("error", err);
          this.isLoading = false;
        }
      );
  }

  public add() {
  //  const dialogRef = this.dialog.open(LanguageEditComponent, {
      //data: serviceDate,
   // });
  }

  public edit(obj) {
    console.log(obj);

    var modal = this.dialog.open(LectionaryTrackEditComponent);
     modal.componentInstance.LoadItem(obj.Id);

    modal.afterClosed().subscribe((savedItem: LectionaryTrack) => {

      console.log("modal closed", savedItem);

      if (savedItem !== undefined) {

        console.log("closed window", savedItem);
        // obj.Name = savedItem.Name;
        // obj.Description = savedItem.Description;
      }

    });

  }

  public delete(lang) {
     alert("Delete obj");
     console.log(lang);
  }

}


export class LectionaryTrack {
  Name: string
}
